// ─────────────────────────────────────────────────────────────────────────────
// Phase 1 问诊化文案 · 集中常量
// 文案源自 /pipeline/竞品移植_ClaudeCode指令_v1.md 已签版本；创始人目验修订优先，
// 中文语境标点统一全角（，：；），信任句用创始人签字版。
// JS 字符串统一用 ASCII / 反引号定界；中文引号仅作内容出现，绝不用作定界符。
// 黑名单与禁令词对本文件同样生效；唯一豁免：
//   3w4「早就放下型」为主诉原词引用，禁令词豁免（创始人 2026-07-28 裁定）。
// ─────────────────────────────────────────────────────────────────────────────

export const COPY = {
  // 1.2 提交按钮（不动）
  submit: "提交问诊",

  // 1.2 提交后固定时长 loading（800–1000ms，非随机、无进度条，剧场只到文案层）
  loading: "调取病历中……找到了，还挺厚。",

  // 1.2 错误态（results.json 加载失败等）
  loadError: "病历柜卡住了，刷新再试一次。",

  // 1.4 信任句（输入框下方小字）· 创始人签字版
  //     前提：funnel_events 与 interest_emails 两表隔离（1.1 已实现）
  emailTrust: "测评选择只用于生成报告与匿名统计，不与邮箱绑定，邮箱只用来寄方子。",

  // 1.5 娱乐向免责声明（页脚 + 结果页底部各一行；字号更小、非红，不替换红字压底句）
  disclaimer: "本报告为娱乐向内容创作，不构成医疗、心理诊断或任何现实建议。",
};

// 1.3 九型选择器 · 病味提示：dropdown 显示「{wing} · {hint}」，value（型号）不变。
export const ENNEAGRAM_HINTS = {
  "1w9": "只是有点累型",
  "1w2": "都是为你好型",
  "2w1": "不求回报型",
  "2w3": "只是顺手型",
  "3w2": "最好一面型",
  "3w4": "早就放下型",
  "4w3": "别人不会懂型",
  "4w5": "没人到得了型",
  "5w4": "没想好怎么回型",
  "5w6": "还没想清楚型",
  "6w5": "未雨绸缪型",
  "6w7": "开玩笑问问型",
  "7w6": "我心大型",
  "7w8": "拜拜就拜拜型",
  "8w7": "懒得计较型",
  "8w9": "需要冷静型",
  "9w8": "都行型",
  "9w1": "你们定型",
};

// 渲染层引号：ASCII 双引号成对替换为「」（不配对的原样保留，不用状态机 toggle）；
// 全角 “ ” 一并归一为「」。卡面与结果页共用同一实现。results.json 原文不改。
export function toCorner(s) {
  return String(s)
    .replace(/"([^"]*)"/g, "「$1」")
    .replace(/“/g, "「")
    .replace(/”/g, "」");
}
